import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { FormGroupFilters } from './model/table-filter.model';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { isEmpty, isNull, isUndefined, toModelDate } from 'app/helper/utils';
import { InputComponent } from '../table-filters-item/input/input.component';
import { InputDateRangeComponent } from '../table-filters-item/input-date-range/input-date-range.component';
import { InputDateComponent } from '../table-filters-item/input-date/input-date.component';
import { SelectSearchSimpleComponent } from '../table-filters-item/select-search-simple/select-search-simple.component';
import { SelectComponent } from '../table-filters-item/select/select.component';

@Component({
    selector: 'app-table-filters',
    templateUrl: './table-filters.component.html',
    styleUrls: ['./table-filters.component.scss'],
    providers: [DatePipe],
    imports: [
        ReactiveFormsModule, NgFor, NgIf, SelectComponent, SelectSearchSimpleComponent,
        InputDateComponent, InputDateRangeComponent, InputComponent
    ]
})
export class TableFiltersComponent implements OnInit, OnChanges {
  @Input() filters: FormGroupFilters[];
  @Output() submitFilters = new EventEmitter();
  @Output() resetFilter = new EventEmitter();
  @Output() changeItems = new EventEmitter();
  @Output() range = new EventEmitter();
  filtersForm: UntypedFormGroup = this.fb.group({});

  constructor(private fb: UntypedFormBuilder, private datePipe: DatePipe) { }

  ngOnInit() {
    this.filtersForm = this.fb.group({});
    this.toFormGroup(this.filters);
  }

  onSubmit() {
    const formModel = this.filtersForm.value;
    const response = {};
    //  format to send API filters
    this.filters.forEach(element => {
      if (element.type !== 'input-date-range') {
        let value = formModel[element.name];
        if (!(isNull(value) || isEmpty(value))) {
          if (element.type === 'input-date') {
            value = this.updateValue(value);
          }
          response[element.name] = value;
        }
      }
    });
    this.submitFilters.emit(response);
  }

  ngOnChanges(change: SimpleChanges) {
    this.toFormGroup(change.filters.currentValue);
  }

  toFormGroup(filters: FormGroupFilters[]) {
    filters.forEach(element => {
      this.filtersForm.addControl(
        element.name.toString(),
        new UntypedFormControl(element.defaultValue)
      );
    });
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filters.forEach(element => {
      this.filtersForm.controls[element.name.toString()].setValue(
        element.defaultValue
      );
    });
    this.sendRange({});
    this.resetFilter.emit();
  }

  changeItem(event) {
    this.changeItems.emit(event);
  }

  updateValue(dateValue) {
    let dateToSave = null;
    const dateFormatted = toModelDate(dateValue);

    if (!(isUndefined(dateValue) && isNull(dateValue))) {
      dateToSave = this.transformDate(dateFormatted);
    }
    return dateToSave;
  }

  sendRange(event) {
    this.range.emit(event);
  }

  transformDate(date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
}
